import React, { useState } from 'react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { CreditCard, Smartphone } from 'lucide-react';
import { Alert, AlertDescription } from './ui/alert';

const PaymentMethodModal = ({ isOpen, onClose, onConfirm, total }) => {
  const [loading, setLoading] = useState(false);

  const handleStripePayment = async () => {
    setLoading(true);
    try {
      // This will redirect to Stripe's secure checkout page
      // Stripe handles ALL payment methods: Credit/Debit cards, Apple Pay, Google Pay
      await onConfirm('Stripe Payment');
    } catch (error) {
      console.error('Payment error:', error);
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Secure Checkout</DialogTitle>
          <DialogDescription>
            Complete your purchase of <span className="font-bold text-indigo-600">${total.toFixed(2)}</span>
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6">
          <Alert>
            <AlertDescription>
              You'll be redirected to Stripe's secure payment page where you can pay with:
            </AlertDescription>
          </Alert>

          <div className="space-y-3">
            {/* Stripe handles all these automatically */}
            <div className="flex items-center gap-3 border rounded-lg p-4 bg-gray-50">
              <CreditCard className="h-6 w-6 text-indigo-600" />
              <div>
                <p className="font-medium">Credit & Debit Cards</p>
                <p className="text-sm text-gray-600">Visa, Mastercard, Amex, Discover</p>
              </div>
            </div>

            <div className="flex items-center gap-3 border rounded-lg p-4 bg-gray-50">
              <Smartphone className="h-6 w-6 text-indigo-600" />
              <div>
                <p className="font-medium">Apple Pay & Google Pay</p>
                <p className="text-sm text-gray-600">Quick and secure digital payments</p>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-sm text-blue-900">
              <strong>Secure Payment:</strong> All payments are processed securely through Stripe. 
              Your card information is never stored on our servers.
            </p>
          </div>

          <div className="flex gap-3 pt-4">
            <Button 
              variant="outline" 
              onClick={onClose} 
              className="flex-1"
              disabled={loading}
            >
              Cancel
            </Button>
            <Button 
              onClick={handleStripePayment} 
              className="flex-1"
              disabled={loading}
            >
              {loading ? 'Processing...' : `Pay $${total.toFixed(2)}`}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentMethodModal;
